/**
 * Get service status for a next service date
 * Returns status object with text and variant for display
 */
export const getServiceStatus = (nextServiceDate) => {
  if (!nextServiceDate) return null;
  
  const serviceDate = new Date(nextServiceDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  serviceDate.setHours(0, 0, 0, 0);
  
  const daysLeft = Math.ceil((serviceDate - today) / (1000 * 60 * 60 * 24));
  
  if (daysLeft < 0) {
    return { text: 'Overdue', variant: 'destructive', daysLeft };
  } else if (daysLeft <= 30) {
    return { text: `${daysLeft} days left`, variant: 'warning', daysLeft };
  } else if (daysLeft <= 60) {
    return { text: `${daysLeft} days left`, variant: 'info', daysLeft };
  }
  return null;
};

/**
 * Get assets that are due for service within specified days
 */
export const getUpcomingServices = (assets, days = 30) => {
  if (!Array.isArray(assets)) return [];
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const futureDate = new Date(today);
  futureDate.setDate(futureDate.getDate() + days);
  
  return assets.filter(asset => {
    if (!asset.nextServiceDate) return false;
    
    const serviceDate = new Date(asset.nextServiceDate);
    serviceDate.setHours(0, 0, 0, 0);
    
    return serviceDate >= today && serviceDate <= futureDate;
  });
};

/**
 * Get assets overdue for service
 */
export const getOverdueServices = (assets) => {
  if (!Array.isArray(assets)) return [];
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  return assets.filter(asset => {
    if (!asset.nextServiceDate) return false;
    
    const serviceDate = new Date(asset.nextServiceDate);
    serviceDate.setHours(0, 0, 0, 0);
    
    return serviceDate < today;
  });
};

